import React from 'react';
import './ChatError.scss';

function ChatError({ children = <></> }: { children?: React.ReactNode }) {
  return <div className="chat-error">{children}</div>;
}

export default ChatError;
